// extracted by mini-css-extract-plugin
export default {"root":"AccountPanel_root__saNzu","account-selector":"AccountPanel_account-selector__eOVJQ"};